var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { ONE_SECOND } from '@lucidlink/uicore';
import { LucidDevToolsKeyFactory } from './LucidDevToolsKeyFactory';
const SERIALIZED_STATS_REFETCH_INTERVAL = ONE_SECOND;
export const useSerializedStats = (statsName, stats) => {
    _react_refresh_temp_1();
    const query = useQuery({
        queryKey: LucidDevToolsKeyFactory.serializedStats(statsName),
        refetchInterval: SERIALIZED_STATS_REFETCH_INTERVAL,
        queryFn: () => stats?.serialize(),
    });
    return { query };
};
_react_refresh_temp_1(useSerializedStats, "c7fxJWDO4uMGjIdKMJSj1aiS9wg=", false, () => [useQuery]);
